import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PathNotFoundComponent } from './module/shared/components/path-not-found/path-not-found.component';
import { LandingComponent } from './module/landing/landing.component';
import { isEntitledGuard } from './module/shared/guards/isEntitled.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [isEntitledGuard],
  },
  {
    path: '**',
    component: PathNotFoundComponent,
    canActivate: [isEntitledGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
